"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTimeValue = buildTimeValue;
function buildTimeValue(value) {
  var onlyDigitsValue = value.replace(/\D/g, '');
  if (onlyDigitsValue.length < 2) {
    return value;
  }
  var firstDigit = parseInt(onlyDigitsValue[0], 10);
  var secondDigit = parseInt(onlyDigitsValue[1], 10);
  if (firstDigit >= 3 || firstDigit === 2 && secondDigit >= 4) {
    var index;
    if (firstDigit >= 3) {
      index = 1;
    } else {
      index = 2;
    }
    return build(onlyDigitsValue, index);
  }
  if (value.length === 2) {
    return value;
  }
  return build(onlyDigitsValue, 2);
}
function build(onlyDigitsValue, index) {
  var hours = onlyDigitsValue.slice(0, index);
  var validHours = Math.min(parseInt(hours, 10), 23);
  var minuteCharacters = onlyDigitsValue.slice(index);
  var parsedMinutes = parseInt(minuteCharacters, 10);
  var validMinutes = Math.min(parsedMinutes, 59);
  return "".concat(validHours.toString().padStart(2, '0'), ":").concat(validMinutes.toString().padStart(2, '0'));
}